import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "name", "apiKey", "options", "valueExpr", "displayExpr", "getOptionValue", "getOptionLabel", "size", "onChange", "value", "loading", "placeholder", "MenuItemProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ExpandMoreRounded } from "@mui/icons-material";
import { CircularProgress, MenuItem, Select } from "@mui/material";
import { useAppSelector } from "../../../../store/hooks";
import { getLoadingKey } from "../../../common/commonFunctions";
export var FormSingleSelect = function (props) {
    var _crud$apiKey;
    var crud = useAppSelector(function (state) { return state.crud; });
    var label = props.label, _a = props.name, name = _a === void 0 ? '' : _a, _b = props.apiKey, apiKey = _b === void 0 ? '' : _b, _c = props.options, options = _c === void 0 ? (_crud$apiKey = crud[apiKey]) === null || _crud$apiKey === void 0 ? void 0 : _crud$apiKey.data : _c, _d = props.valueExpr, valueExpr = _d === void 0 ? 'id' : _d, _e = props.displayExpr, displayExpr = _e === void 0 ? 'Name' : _e, _f = props.getOptionValue, getOptionValue = _f === void 0 ? function (option) { return valueExpr ? option === null || option === void 0 ? void 0 : option[valueExpr] : option; } : _f, _g = props.getOptionLabel, getOptionLabel = _g === void 0 ? function (option) { return displayExpr ? option === null || option === void 0 ? void 0 : option[displayExpr] : option; } : _g, _h = props.size, size = _h === void 0 ? 'small' : _h, onChange = props.onChange, value = props.value, _j = props.loading, loading = _j === void 0 ? false : _j, placeholder = props.placeholder, MenuItemProps = props.MenuItemProps, others = _objectWithoutProperties(props, _excluded);
    loading = loading || (apiKey ? crud[getLoadingKey(apiKey)] === 'loading' : false);
    return /*#__PURE__*/ React.createElement(Select, _extends({
        defaultValue: 'placeholder',
        size: size,
        value: value,
        fullWidth: true,
        placeholder: placeholder,
        IconComponent: loading ? function (props) { /*#__PURE__*/ return React.createElement(CircularProgress, _extends({}, props, {
            size: 16
        })); } : ExpandMoreRounded
    }, others, {
        sx: _objectSpread({
            color: value ? 'text.primary' : 'text.tertiary',
            lineHeight: '20px'
        }, others.sx)
    }), placeholder && /*#__PURE__*/ React.createElement(MenuItem, _extends({
        id: "placeholder",
        key: 'placeholder',
        value: "placeholder",
        onClick: function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(e, null); },
        sx: {
            color: 'text.tertiary'
        }
    }, MenuItemProps), placeholder), Array.isArray(options) && (options === null || options === void 0 ? void 0 : options.map(function (item) { return item && /*#__PURE__*/ React.createElement(MenuItem, _extends({
        id: getOptionValue(item),
        key: getOptionValue(item),
        value: getOptionValue(item),
        onClick: function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(e, item); }
    }, MenuItemProps), getOptionLabel(item)); })));
};
